"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  USER_CANNOT_BE_CREATED: 'user_cannot_be_created',
  NOT_CONFIRMED: 'not_confirmed',
  ALREADY_CONFIRMED: 'already_confirmed',
  INVALID_CREDENTIALS: 'invalid_credentials',
  INVALID_CURRENT_PASSWORD: 'invalid_current_password',
  INVALID_EMAIL: 'invalid_email',
  GATEWAY_TIMEOUT: 'gateway_timeout',
  NOT_FOUND: 'not_found',
  PARAM_IS_MISSING: 'param_is_missing',
  INVALID_PARAMS: 'invalid_params',
  INVALID_PARAM: 'invalid_param',
  RECORD_NOT_UNIQUE: 'record_not_unique_error',
  APISAUCE_TIMEOUT: 'TIMEOUT_ERROR',
  POLLING_TIMEOUT: 'PollingTimeoutError',
  NETWORK_ERROR: 'NETWORK_ERROR',
  NOT_AUTHORIZED: 'not_authorized',
  AUTH_TOKEN_EXPIRED: 'auth_token_expired',
  USER_ERROR: 'user_error',
  TIMEOUT_ERROR: 'TIMEOUT_ERROR',
  SERVER_ERROR: 'Server Error',
  TOO_MANY_FORM_RESPONSES: 'too_many_form_responses',
  ROUTING_ERROR: 'routing_error'
};